import {StyleSheet} from 'react-native';
import {connect} from 'react-redux';
import {constant} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import OrderDetail from '/component/partial/OrderDetail';

const styles = StyleSheet.create({base: {paddingTop: 10}});

export default connect(
  createStructuredSelector({
    style: constant(styles),
  }),
)(OrderDetail);
